import { render } from "./RemindersMenu.vue?vue&type=template&id=9536c922&scoped=true"
import script from "./RemindersMenu.vue?vue&type=script&lang=js"
export * from "./RemindersMenu.vue?vue&type=script&lang=js"

import "./RemindersMenu.vue?vue&type=style&index=0&id=9536c922&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9536c922"]])

export default __exports__